import React from "react";
import FooterOfRentPrint from "./FooterOfRentPrint";
import TableScrolePrint from "./TableScrolePrint";

const TableRentAllPrint = () => {
  return (
    <div>
      <TableScrolePrint />
      <br />
      <br />
      <FooterOfRentPrint />
    </div>
  );
};

export default TableRentAllPrint;
